<template>
  <div class="jl-auction-wrap">
    <div class="jl-auc-section1">
      <div class="jl-container">
        <div class="jl-auc-topbox">
          <h2 class="jl-auc-title">锦鲤拍卖中心</h2>

          <div class="jl-auc-topcont clearfix" v-if="haveAuction">
            <div class="item-left">
              <img :src="nowObj.imgUrl" alt />
            </div>
            <div class="item-right">
              <div class="jl-auc-top-rtop">
                <h2>{{ nowObj.title }}</h2>
                <div
                  class="jl-auc-top-tips"
                  v-if="nowObj.transactionType === 0"
                >
                  未开始
                </div>
                <div
                  class="jl-auc-top-tips"
                  v-if="nowObj.transactionType === 1"
                >
                  进行中
                </div>
                <div
                  class="jl-auc-top-tips"
                  v-if="nowObj.transactionType === 2"
                >
                  已结束
                </div>
              </div>
              <div class="jl-auc-top-count-wrap">
                <div class="item">
                  <img src="../../assets/img/zkj-renqun.png" alt />
                  <span>设置提醒人数：</span>
                  <span>{{ numObj.remindNumber }}</span>
                </div>
                <div class="item">
                  <img src="../../assets/img/zkj-liulan.png" alt />
                  <span>浏览人数：</span>
                  <span>{{ numObj.visitorsNumber }}</span>
                </div>
                <div class="item">
                  <img src="../../assets/img/zkj-canyu.png" alt />
                  <span>参与人数：</span>
                  <span class="active">{{ numObj.joinNumber }}</span>
                </div>
              </div>
              <div class="jl-auc-top-time">
                <div class="item-box">
                  <p class="text1">
                    {{
                      nowObj.transactionType === 1
                        ? '距离结束'
                        : nowObj.transactionType === 0
                        ? '距离开始'
                        : '截止时间'
                    }}
                  </p>
                  <div
                    class="item-time-box"
                    v-if="nowObj.transactionType !== 2"
                  >
                    <span class="active">{{ hh }}</span>
                    <span>时</span>
                    <span class="active">{{ mm }}</span>
                    <span>分</span>
                    <span class="active">{{ ss }}</span>
                    <span>秒</span>
                  </div>
                  <div class="item-time-box" v-else>
                    <p class="text-end-time">{{ nowObj.expectEndDate }}</p>
                  </div>
                </div>
              </div>
              <div class="jl-auc-top-send">
                <a @click="goLink(nowObj)" class="btn">查看详情</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="jl-auc-section2" id="jl-auc-section2-point">
      <div class="jl-container">
        <p class="jl-auc-list-title">往期回顾</p>
        <div v-loading="isloading" class="jl-loading-box">
          <div class="jl-com-nodata-tips" v-if="nodata">
            <div class="jl-com-nodata-box">
              <i class="jl-icon-wushuju"></i>
              <p class="text">暂无数据</p>
            </div>
          </div>
          <ul class="jl-auc-list clearfix">
            <li
              class="item"
              v-for="item in list"
              :key="item.id"
              @click="goLink(item)"
            >
              <div class="item-box">
                <div class="item-img">
                  <img :src="item.imgUrl" alt />
                </div>
                <div class="item-text">
                  <div class="grid1">
                    <p class="text1">{{ item.title }}</p>
                    <!-- <p class="text2">{{item.status?'已结束':'进行中'}}</p> -->
                    <p class="text2">已结束</p>
                  </div>
                  <div class="grid2">
                    <div class="grid-item clearfix">
                      <p class="text3">设置提醒人数：{{ item.remindNumber }}</p>
                      <p class="text3">浏览人数：{{ item.visitorsNumber }}</p>
                      <p class="text3 alt-r">
                        参与人数：
                        <span>{{ item.joinNumber }}</span>
                      </p>
                    </div>
                    <div class="grid2-time">
                      时间：{{ item.startDate }} ～ {{ item.expectEndDate }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div style="text-align:center;" v-if="list.length > 0">
          <div style="display:inline-block;">
            <v-pagination
              :total="total"
              :display="display"
              :currentPage="current"
              @pagechange="pagechange"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auctionPastList, auctionNow } from '../../api/auction';
import Pagination from '@/components/Pagination';
export default {
  name: 'auctionIndex',
  components: {
    'v-pagination': Pagination
  },
  data() {
    return {
      nowObj: {},
      list: [],
      total: 1,
      display: 6,
      current: 1,
      hh: '', //时
      mm: '', //分
      ss: '', //秒
      numObj: {
        joinNumber: 0, //参与人数
        visitorsNumber: 0, //浏览人数
        remindNumber: 0 //设置人数
      },
      haveAuction: false, //是否有当期拍卖
      listScrollTop: '', //往期回顾距离顶部距离
      isloading: true,
      nodata: false,
      ctime: null,
      ctimeRe: null
    };
  },
  created() {
    this.getlist();
    this.refr();
  },
  destroyed() {
    clearTimeout(this.ctime);
    clearTimeout(this.ctimeRe);
  },
  mounted() {
    this.$nextTick(() => {
      this.listScrollTop = this.$publicMethods.getPoint(
        document.getElementById('jl-auc-section2-point')
      ).t;
    });
  },

  methods: {
    format(value) {
      //为了兼容ie9时间格式
      if (value) {
        var tt = value.replace(/-/g, '/');
        var time = new Date(tt);
        return time;
      } else {
        return '';
      }
    },
    setTime() {
      let type = this.nowObj.transactionType,
        time = '';
      if (type === 1) {
        time = this.nowObj.endDate
          ? this.nowObj.endDate
          : this.nowObj.expectEndDate;
      } else if (type === 0) {
        time = this.nowObj.startDate;
      }
      let numTime = (this.format(time) - new Date()) / 1000;
      this.setIntervalTime(numTime);
    },
    setIntervalTime(numTime) {
      let h = parseInt(numTime / 3600),
        m = parseInt((numTime - h * 3600) / 60),
        s = parseInt(numTime - h * 3600 - m * 60);
      this.hh = h < 10 ? '0' + h : h;
      this.mm = m < 10 ? '0' + m : m;
      this.ss = s < 10 ? '0' + s : s;
      numTime -= 1;
      if (numTime < 0) {
        clearTimeout(this.ctime);
        clearTimeout(this.ctimeRe);
        this.getlist();
      } else {
        this.ctime = setTimeout(() => {
          this.setIntervalTime(numTime);
        }, 1000);
      }
    },
    setPersonNum(arr = []) {
      let joinNumber = 0,
        visitorsNumber = 0,
        remindNumber = 0,
        obj = {};
      arr.forEach(element => {
        joinNumber += parseFloat(element.joinNumber);
        visitorsNumber += parseFloat(element.visitorsNumber);
        remindNumber += parseFloat(element.remindNumber);
      });

      obj.joinNumber = joinNumber;
      obj.visitorsNumber = visitorsNumber;
      obj.remindNumber = remindNumber;
      return obj;
    },

    pagechange(idx) {
      this.current = idx;
      auctionPastList(this);
      window.scrollTo(0, this.listScrollTop);
    },
    getlist() {
      clearTimeout(this.ctime);
      clearTimeout(this.ctimeRe);
      auctionPastList(this);
      auctionNow(this, res => {});
    },
    goLink(item) {
      this.$router.push({
        name: 'auctionView',
        query: {
          id: item.id
        }
      });
    },
    //十秒刷新
    refr() {
      clearTimeout(this.ctimeRe);
      this.ctimeRe = setTimeout(() => {
        auctionNow(this);
        this.refr();
      }, 10000);
    }
  }
};
</script>

<style lang="scss" scoped>
.imgTransform {
  position: relative;
  text-align: center;
  overflow: hidden;
  &::after {
    /* content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%; */
  }

  img {
    /* display: inline-block;
    vertical-align: middle;
    max-width: 100%;
    max-height: 100%; */
    display: block;
    width: 100%;
    transition: transform 0.3s;
  }
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-auc-section1 {
  background: url('../../assets/img/paimai_banner.png') no-repeat;
  background-size: cover;
  .jl-auc-topbox {
    padding-top: 72px;
    padding-bottom: 77px;
  }
  .jl-auc-title {
    position: relative;
    font-size: 52px;
    color: #333;
    line-height: 1;
    padding-bottom: 40px;
    margin-bottom: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 55px;
      height: 3px;
      background: #333;
    }
  }
  .jl-auc-topcont {
    background: rgba($color: #fff, $alpha: 0.7);
    box-shadow: 0 0 18px rgba($color: #042868, $alpha: 0.3);
    height: 600px;
    .item-left {
      position: relative;
      float: left;
      width: 67%;
      height: 100%;
      @extend .imgTransform;
    }
    .item-right {
      float: right;
      width: 33%;
      height: 100%;
      padding: 70px 0 0 30px;
    }
    .jl-auc-top-rtop {
      position: relative;
      margin-bottom: 26px;
      h2 {
        font-size: 28px;
        color: #333;
      }
      .jl-auc-top-tips {
        position: absolute;
        right: 0;
        top: 0;
        width: 80px;
        height: 28px;
        background: url('../../assets/img/zkj-tips.png') no-repeat;
        color: #fff;
        font-size: 14px;
        line-height: 28px;
        padding-left: 28px;
      }
    }
    .jl-auc-top-count-wrap {
      margin-bottom: 55px;
      .item {
        position: relative;
        padding-left: 32px;
        margin-bottom: 10px;
        img {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        span {
          font-size: 14px;
          color: #333;
          &.active {
            color: #e50011;
          }
        }
      }
    }
    .jl-auc-top-time {
      padding-right: 30px;
      margin-bottom: 50px;
      .item-box {
        padding: 28px;
        background: #fff8f9;
        border: 1px solid #ffc6ca;
        .text1 {
          font-size: 18px;
          color: #333;
          margin-bottom: 28px;
        }
      }
      .item-time-box {
        font-size: 0;
        margin-right: -20px;
        span {
          display: inline-block;
          vertical-align: middle;
          font-size: 24px;
          color: #333;
          width: 46px;
          height: 52px;
          line-height: 52px;
          text-align: center;
          &.active {
            width: 52px;
            font-size: 28px;
            color: #fff;
            background: #e50011;
          }
        }
      }
    }
    .jl-auc-top-send {
      text-align: center;
      .btn {
        display: inline-block;
        width: 128px;
        height: 38px;
        text-align: center;
        font-size: 14px;
        color: #333;
        line-height: 38px;
        border: 1px solid #333;
        transition: all 0.3s;
      }
    }
  }
}
.jl-auc-section2 {
  background: #f8f8fb;
  padding-bottom: 110px;
  padding-top: 27px;
  .jl-auc-list-title {
    font-size: 18px;
    line-height: 1;
    color: #333;
    padding-left: 8px;
    border-left: 4px solid #e50011;
    margin-bottom: 27px;
  }
  .jl-auc-list {
    margin-left: -20px;
    margin-right: -20px;
    .item {
      float: left;
      width: 50%;
      padding: 0 20px 40px 20px;
      cursor: pointer;
    }
    .item-box {
      padding: 20px;
      background: #fff;
      box-shadow: 0 0 13px rgba($color: #a5acb1, $alpha: 0.3);
    }
    .item-img {
      position: relative;
      // height: 405px;
      overflow: hidden;
      text-align: center;
      &::before {
        /*  content: "";
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%; */
      }
      img {
        /* display: inline-block;
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%; */
        display: block;
        width: 100%;
        transition: all 0.3s;
      }
    }
    .item-text {
      .grid1 {
        position: relative;
        padding: 19px 0 21px 0;
        border-bottom: 1px solid #e0e0e0;
        .text1 {
          font-size: 18px;
          color: #333;
        }
        .text2 {
          position: absolute;
          right: 0;
          top: 50%;
          width: 71px;
          height: 24px;
          margin-top: -12px;
          border: 1px solid #ccc;
          border-radius: 12px;
          font-size: 12px;
          color: #ccc;
          text-align: center;
          line-height: 24px;
          &::before {
            content: '';
            position: absolute;
            left: 10px;
            top: 50%;
            width: 4px;
            height: 4px;
            background: #ccc;
            border-radius: 2px;
            margin-top: -2px;
          }
        }
      }
      .grid2 {
        padding-top: 15px;
      }
      .grid-item {
        margin-bottom: 10px;
        .text3 {
          float: left;
          font-size: 14px;
          color: #333;
          margin-right: 40px;
          &.alt-r {
            float: right;
            font-weight: bold;
            color: #000;
            margin-right: 0;
            span {
              color: #e50011;
            }
          }
        }
      }
      .grid2-time {
        font-size: 14px;
        color: #333;
      }
    }
  }
}

.text-end-time {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}
@media screen and (min-width: 1200px) {
  .jl-auc-section1 .jl-auc-topcont .jl-auc-top-send .btn:hover {
    color: #fff;
    border-color: #e50011;
    background: #e50011;
  }
  .imgTransform:hover {
    img:hover {
      transform: scale(1.1);
    }
  }
  .jl-auc-section2 .jl-auc-list .item-img img:hover {
    transform: scale(1.1);
  }
}
</style>
